/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of ConfigurationsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import { ConfigurationName } from '../../types';
import {
  SuccessResponse_1OfGetConfigurationResponse,
  UpdateConfigurationRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockConfigurations = [
  { id: 1, name: 'CreditRequestsEnabled', value: 'true', storeNumber: 'STORE001', franchiseName: 'Demo' },
  { id: 2, name: 'ShowStockOnHand', value: 'true', storeNumber: 'STORE001', franchiseName: 'Demo' },
  { id: 3, name: 'AllowEmergencyOrders', value: 'false', storeNumber: 'STORE001', franchiseName: 'Demo' },
  { id: 4, name: 'DefaultOrderType', value: '1', storeNumber: 'STORE001', franchiseName: 'Demo' },
];

/* ---- Mocked Client Implementation ---- */

import { IConfigurationsClient } from '../../interfaces';
export class ConfigurationsClientMocked implements IConfigurationsClient {
  constructor(baseUrl?: string) {}

  async configurationsGET(franchiseName?: string, storeNumber?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfGetConfigurationResponse> {
    await delay();
    const configs = mockConfigurations.filter(
      (c) => (!franchiseName || c.franchiseName === franchiseName) && (!storeNumber || c.storeNumber === storeNumber)
    );
    return successResponse({ configurations: configs }) as SuccessResponse_1OfGetConfigurationResponse;
  }

  async name(configurationName: ConfigurationName, storeNumber: string, franchiseName: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfGetConfigurationResponse> {
    await delay();
    const config = mockConfigurations.find(
      (c) => c.name === String(configurationName) && c.storeNumber === storeNumber && c.franchiseName === franchiseName
    );
    return successResponse({ configurations: config ? [config] : [] }) as SuccessResponse_1OfGetConfigurationResponse;
  }

  async configurationsPATCH(id: number, body?: UpdateConfigurationRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const config = mockConfigurations.find((c) => c.id === id);
    if (config && body) {
      config.value = body.value || config.value;
    }
  }

  // ====== Auto-generated stub methods ======












}
